module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mhip0-cad7f8a11a66e27f8f2e7c90889751f0.jpg";